import React from 'react';
import ReactDOM from 'react-dom/client';
import './setupAuth'; // Global fetch interceptor for auth
import App from './App';
import './styles/GlobalStyles.css';
import './App.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
